import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { ArrowRightCircle } from 'react-bootstrap-icons';
import HeaderImg from '../assets/img/serviceimg2.png';
import {useState,useEffect} from 'react';



const Banner=()=>{

    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(300 - Math.random() * 100);
    const [index, setIndex] = useState(1);
    const toRotate = [ "#AI/ML", "#Agumented Reality", "#Computer Vision" ];
    const period = 10;
  
    useEffect(() => {
      let ticker = setInterval(() => {
        tick();
      }, delta);
  
      return () => { clearInterval(ticker) };
    }, [text])
  
    const tick = () => {
      let i = loopNum % toRotate.length;
      let fullText = toRotate[i];
      let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);
  
      setText(updatedText);
  
      if (isDeleting) {
        setDelta(prevDelta => prevDelta / 2);
      }
  
      if (!isDeleting && updatedText === fullText) {
        setIsDeleting(true);
        setIndex(prevIndex => prevIndex - 1);
        setDelta(period);
      } else if (isDeleting && updatedText === '') {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
        setIndex(1);
        setDelta(500);
      }
      else {
        setIndex(prevIndex => prevIndex + 1);
      }
    }
    return(
      <section className='banner' id='home'>
          <Container>
              <Row className="align-items-center">
                  <Col xs={12} md={6} xl={7}>
                      <span className='tagline'>Power Your Device With</span>
                      <h1 className="bnr-hdng">{`Autoverse Semiconductor`}<br></br> <span className="txt-rotate" dataperiod="1000" ><span className="wrap">{text}</span></span></h1>
                      <p>
                          AI here, ML there in recent times the terms Artificial Intelligence 
                          AI and Machine Learning ML have become very popular. 
                          They play a prominent role in most conversations about the future of technology,
                          business, the workplace and even humanity itself. 
                      </p>
                      <button onClick={()=>console.log('connect')}>
                          Let's Connect<ArrowRightCircle size={25}/>
                      </button>
                  </Col>
                  <Col xs={12} md={6} xl={5}>
                      <img src={HeaderImg} alt="Header Img" className="bnr_img" />
                  </Col>
              </Row>
          </Container>
      </section>
    )
}

export default Banner